<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!--  사업장 정보-->
    <div class="mt-28px">
      <h5 class="mb-5"><i class="dot"></i> 사업장 정보</h5>

      <div class="writeGridContainer">
        <div>
          <div>작업내용</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
          <ml-input v-else v-model="form.inputB_1" :readonly="board.readonly" />
        </div>
        <div>
          <div>조사일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
          <date-selector v-else v-model="form.inputB_5" :readonly="board.readonly" />
        </div>

        <div>
          <div>작업자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
          <ml-input v-else v-model="form.inputB_4" :readonly="board.readonly" />
        </div>
        <div>
          <div>수행일시</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
          <date-selector v-else v-model="form.inputB_2" :readonly="board.readonly" />
        </div>
        <div>
          <div>확인자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>
          <ml-input v-else v-model="form.inputB_3" :readonly="board.readonly" />
        </div>
        <div>
          <div>점검장소</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_6 }}</p>
          <ml-input v-else v-model="form.inputB_6" :readonly="board.readonly" />
        </div>
        <div>
          <div>재해형태(필수)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_7 }}</p>
          <disaster-class-selector v-else v-model="form.inputB_7" :readonly="board.readonly" :custom-disaster-list="customDisasterList" multiple />
        </div>
      </div>
    </div>

    <table-inspect
      class="mt-28px"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="'유해·위험요인 조사표'"
      :list="form.inspectList_1"
      :is-note="true"
      :table-header-title="'항목 및 내용'"
      :table-header-yes="'작성'"
      :table-header-no="'미작성'"
      :table-header-note="'비고'"
      @update-list-check="updateListCheck_1"
    />

    <!--    사진대지-->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="신축현장 점검" class="mt-28px" />

    <!--    파일첨부-->
    <file-upload-module id="fileList" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly" class="mt-28px" />
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import {researchDisasters} from "@/util/DisasterDataResearch";

export default {
  components: {
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.inspectList_1 || this.form.inspectList_1.length === 0) {
          this.form.inspectList_1 = this.inspectTable_1;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.summary = {
          위험요인파악_사업장명: [],
          위험요인파악_공정명: [],
        };

        value.summary["위험요인파악_사업장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        value.summary["위험요인파악_공정명"].push({
          [this.form.inputB_1]: 1,
        });

        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: [],

        photoList: [],
        fileList: [],
        inspectList_1: [],
      },
      customDisasterList: researchDisasters,
    };
  },
  computed: {
    inspectTable_1() {
      return [
        {
          id: 1,
          label: "안전보건관리책임자, 작업자의 참여를 바탕으로 위험요인을 주기적으로 파악",
          is_checked: "",
          note: "",
        },
        {
          id: 2,
          label: "근로자뿐만 아니라 도급,위탁,용역 등 모든 구성원이 위험요인을 신고·제보할 수 있는 절차를 운영",
          is_checked: "",
          note: "",
        },
        {
          id: 3,
          label: "산업재해 및 아차사고를 조사하여 위험요인을 파악",
          is_checked: "",
          note: "",
        },
        {
          id: 4,
          label: "동종업체의 산업재해를 조사 및 참고하여 위험요인을 파악",
          is_checked: "",
          note: "",
        },
        {
          id: 5,
          label: "파악한 위험요인을 유형별로 정리",
          is_checked: "",
          note: "",
        },
        {
          id: 6,
          label: "보유하고 있는 위험기계·기구·설비,유해·위험 화학물질 현황을 관리대장 등을 통해 관리",
          is_checked: "",
          note: "",
        },
        {
          id: 7,
          label: "새로운 기계·기구·설비 또는 화학물질 도입 시 사전에 위험요인을 파악하는 절차를 두고 관리",
          is_checked: "",
          note: "",
        },
        {
          id: 8,
          label: "위험장소에 안전보건표지를 부착하고, 출입 및 작업 시 별도로 관리하는 절차 여부",
          is_checked: "",
          note: "",
        },
        {
          id: 9,
          label: "작업방법을 고려한 위험요인을 파악",
          is_checked: "",
          note: "",
        },
        {
          id: 10,
          label: "새로운 작업의 경우 작업위험성평가 등을 실시하여 작업 위험을 파악",
          is_checked: "",
          note: "",
        },
      ];
    },
  },
  methods: {
    updateListCheck_1(indexRows, text) {
      this.form.inspectList_1[indexRows].is_checked = text;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
